module.exports = __webpack_public_path__ + "static/media/healthcare_heart.4007fcc7.webp";